import type { AutocompleteInputChangeReason } from '@mui/material';

export const ADDRESS_SEARCH_MIN_LENGTH = 4;
export const ADDRESS_SEARCH_DEBOUNCE_MS = 600;

const countNonSpaceCharacters = (searchTerm: string) =>
  searchTerm.replace(/\s/g, '').length;

export const shouldRunAddressSearch = (searchTerm: string) =>
  countNonSpaceCharacters(searchTerm) >= ADDRESS_SEARCH_MIN_LENGTH;

export const nextAddressSearchQuery = (
  currentSearchQuery: string,
  newInputValue: string,
  reason: AutocompleteInputChangeReason,
) => {
  if (reason === 'input') return newInputValue;
  if (reason === 'clear') return '';
  return currentSearchQuery;
};

export const shouldCancelPendingAddressSearch = (
  reason: AutocompleteInputChangeReason,
) => reason === 'clear' || reason === 'reset';
